const featuresQuotas: {
  name: string;
  basic: string;
  indie: string;
  pro: string;
}[] = [
  {
    name: "Active Storage",
    basic: "1 GB",
    indie: "100 GB",
    pro: "500 GB"
  },
  {
    name: "Projects",
    basic: "2",
    indie: "Unlimited",
    pro: "Unlimited"
  },
  {
    name: "Collaborators",
    basic: "1",
    indie: "4",
    pro: "Unlimited"
  }
  // TODO: Finish implementing sessions
  // {
  //   name: "Live Sessions",
  //   basic: "40 minutes",
  //   indie: "Unlimited",
  //   pro: "Unlimited"
  // }
];

const featuresFlags: {
  name: string;
  basic: boolean;
  indie: boolean;
  pro: boolean;
}[] = [
  {
    name: "Review Links",
    basic: true,
    indie: true,
    pro: true
  },
  {
    name: "Playlist Links",
    basic: true,
    indie: true,
    pro: true
  },
  {
    name: "Metadata (ID3v2)",
    basic: true,
    indie: true,
    pro: true
  },
  {
    name: "Lossless Streaming",
    basic: false,
    indie: true,
    pro: true
  },
  {
    name: "Configurable Downloads",
    basic: false,
    indie: true,
    pro: true
  },
  {
    name: "Revokable Link Access",
    basic: false,
    indie: true,
    pro: true
  },
  {
    name: "Custom Branding",
    basic: false,
    indie: false,
    pro: true
  },
  {
    name: "Password-protection",
    basic: false,
    indie: false,
    pro: true
  },
  {
    name: "Expiring Links *",
    basic: false,
    indie: false,
    pro: true
  },
  {
    name: "Embeddable Playlists *",
    basic: false,
    indie: false,
    pro: true
  },
  {
    name: "Link Analytics *",
    basic: false,
    indie: true,
    pro: true
  }
];

export default {
  featuresFlags,
  featuresQuotas
};
